import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
import {WaTagDirective} from 'angular-awesome';
@Component({
	selector:'jwebmp-comp-wa-drawer',
	templateUrl:'./WaDrawerPage.html',
	styles: [],
	styleUrls:['./WaDrawerPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
		WaTagDirective,
],
	standalone:true
})
export class WaDrawerPage
{
	mdContent_332 = `\`\`\`java
import com.jwebmp.webawesome.components.drawer.WaDrawer;
\`\`\``;
	mdContent_333 = `\`\`\`java
new WaDrawer<>()
\`\`\``;
	mdContent_334 = `\`\`\`java
var drawer = new WaDrawer<>();
drawer.setLabel("Settings");
drawer.setPlacement(Placement.End);
drawer.setOpen(true);
\`\`\``;
}
